import { create } from 'zustand';
import { CompanyEvent } from '@/lib/api';

interface EventStore {
  currentEvent: CompanyEvent | null;
  isLoading: boolean;
  error: string | null;
  setCurrentEvent: (event: CompanyEvent | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearEvent: () => void;
}

export const useEventStore = create<EventStore>()((set) => ({
  currentEvent: null,
  isLoading: false,
  error: null,
  setCurrentEvent: (event) => set({ currentEvent: event, error: null }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  clearEvent: () => set({ currentEvent: null, error: null }),
}));